import {
  PanAndZoomStoreActionBase,
  PanAndZoomStoreActionPan,
  PanAndZoomStoreActionType,
  PanAndZoomStoreActionZoom,
} from './panAndZoomStore.types';

export const startPan = (
  clientX: number,
  clientY: number,
  innerElement: HTMLDivElement
): PanAndZoomStoreActionPan => ({
  type: PanAndZoomStoreActionType.PAN_START,
  clientX,
  clientY,
  innerElement,
});

export const pan = (
  clientX: number,
  clientY: number,
  innerElement: HTMLDivElement
): PanAndZoomStoreActionPan => ({
  type: PanAndZoomStoreActionType.PAN,
  clientX,
  clientY,
  innerElement,
});

export const zoom = (
  deltaY: number,
  clientX: number,
  clientY: number,
  containerRect: DOMRect
): PanAndZoomStoreActionZoom => ({
  type: PanAndZoomStoreActionType.ZOOM,
  deltaY,
  clientX,
  clientY,
  containerRect,
});

export const reset = (): PanAndZoomStoreActionBase => ({
  type: PanAndZoomStoreActionType.RESET,
});
